import { render, staticRenderFns } from "./applet_list_detail.vue?vue&type=template&id=1132ba92&scoped=true&"
import script from "./applet_list_detail.vue?vue&type=script&lang=js&"
export * from "./applet_list_detail.vue?vue&type=script&lang=js&"
import style0 from "./applet_list_detail.vue?vue&type=style&index=0&id=1132ba92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132ba92",
  null
  
)

export default component.exports